import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSkull = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 19,
	viewBox: "0 0 16 19",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M7.16927 12.6667L7.41344 12.3583C7.69094 12.0083 7.8301 11.8333 8.0026 11.8333C8.1751 11.8333 8.31427 12.0083 8.59177 12.3583L8.83594 12.6667M6.7526 8.70833C6.7526 8.32156 6.59896 7.95063 6.32547 7.67714C6.05198 7.40365 5.68104 7.25 5.29427 7.25C4.9075 7.25 4.53656 7.40365 4.26307 7.67714C3.98958 7.95063 3.83594 8.32156 3.83594 8.70833C3.83594 9.09511 3.98958 9.46604 4.26307 9.73953C4.53656 10.013 4.9075 10.1667 5.29427 10.1667C5.68104 10.1667 6.05198 10.013 6.32547 9.73953C6.59896 9.46604 6.7526 9.09511 6.7526 8.70833ZM12.1693 8.70833C12.1693 8.32156 12.0156 7.95063 11.7421 7.67714C11.4686 7.40365 11.0977 7.25 10.7109 7.25C10.3242 7.25 9.95323 7.40365 9.67974 7.67714C9.40625 7.95063 9.2526 8.32156 9.2526 8.70833C9.2526 9.09511 9.40625 9.46604 9.67974 9.73953C9.95323 10.013 10.3242 10.1667 10.7109 10.1667C11.0977 10.1667 11.4686 10.013 11.7421 9.73953C12.0156 9.46604 12.1693 9.09511 12.1693 8.70833Z",
		stroke: "#A0A0A0",
		strokeWidth: 1.2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M9.66797 17.25V16M6.33464 17.25V16M8.0013 1C4.08964 1 0.917969 4.13833 0.917969 8.01083C0.917969 9.47167 1.36964 10.8292 2.14297 11.9525C1.93214 12.1858 1.8038 12.4925 1.8038 12.83C1.8038 13.5558 2.39797 14.145 3.1313 14.145V15.1608C3.1313 15.7025 3.38964 16.2183 3.8563 16.4917C6.5313 18.0583 9.47214 18.0583 12.1463 16.4917C12.613 16.2183 12.8713 15.7017 12.8713 15.1608V14.1442C13.6046 14.1442 14.1988 13.5558 14.1988 12.83C14.1988 12.4925 14.0705 12.185 13.8596 11.9525C14.6596 10.7939 15.087 9.41878 15.0846 8.01083C15.0846 4.13833 11.913 1 8.0013 1Z",
		stroke: "#A0A0A0",
		strokeWidth: 1.2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgSkull;
